import { ReactNode } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  Text,
  Flex
} from '@blockanalitica/ui';
import { InfoIcon } from '@/components';
import type { Size } from '@blockanalitica/ui/package/types/src/theme/types';

export interface InfoTooltipProps {
  text: string | ReactNode;
  iconSize?: Size | string | number;
  textSize?: Size | string | number;
  containerProps?: React.ComponentProps<typeof Flex>;
}

export default function InfoTooltip({
  text,
  iconSize = '0',
  textSize = '3',
  containerProps
}: InfoTooltipProps) {
  const tooltipContent =
    typeof text === 'string' ? (
      <Flex maxWidth="300px">
        <Text
          size={typeof textSize === 'number' ? textSize.toString() : textSize}>
          {text}
        </Text>
      </Flex>
    ) : (
      <Flex maxWidth="300px" {...containerProps}>
        {text}
      </Flex>
    );

  return (
    <Tooltip>
      <TooltipTrigger>
        <InfoIcon size={iconSize} />
      </TooltipTrigger>
      <TooltipContent style={{ zIndex: 9999, lineHeight: '1.6' }}>
        {tooltipContent}
      </TooltipContent>
    </Tooltip>
  );
}
